import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZCategoryType = z.object({
  category_type_id: z.string(),
  category_type_name: z.string()
})

export const ZCategoriesData = z.array(ZCategoryType)

export const ZCategoriesApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(ZCategoriesData),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type CategoryType = z.infer<typeof ZCategoryType>

export function assetCategoriesService (
  onSuccess: (assetCategories: CategoryType[], httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): void {
  const url = '/assetrest/api/v2/udp/tiq/assets/categories'
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined && error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
